import React from 'react'
import PropTypes from 'prop-types'
import { v4 } from 'uuid'

import testimonialsStyles from './testimonials.module.sass'

// Testimonials.propTypes = {
//   testimonials: PropTypes.arrayOf(
//     PropTypes.shape({
//       quote: PropTypes.string,
//       author: PropTypes.string,
//     })
//   ),
// }

// export default Testimonials

const pigEmojis = ['🐽', '🐷', '🐖']
export default props => {
  const { acf, addClasses } = props
  const testimonials = Object.values(acf.testimonials)[0] // Testimonials is received as an object rather than an array

  return (
    <div className={[testimonialsStyles.testimonials, addClasses].join(' ')}>
      <div className={testimonialsStyles.content}>
        {testimonials &&
          testimonials.map((testimonial, index) => (
            <blockquote key={v4()} className={testimonialsStyles.testimonial}>
              <span
                className={testimonialsStyles.icon}
                role="img"
                aria-label="Pig Avatar"
              >
                {pigEmojis[index]}
              </span>
              <div className={testimonialsStyles.text}>
                <p className={testimonialsStyles.quote}>
                  {testimonial.testimonial_quote}
                </p>
                <cite className={testimonialsStyles.author}>
                  &nbsp;–&nbsp;
                  {testimonial.testimonial_author}
                </cite>
              </div>
            </blockquote>
          ))}
      </div>
    </div>
  )
}
